<app-dialog-base [showLoadingSpinner]="uiState === uiStateEnumForTemplate.ShowLoading">
  <span dialog-title>Edit Notification Delivery Settings</span>

  <ng-container dialog-content>
    <p data-testid="notification-delivery-explainer">
      These control how fast draw reminders are pushed out, not when they start. Players are sent in batches
      of the chunk size, one batch every frequency seconds. If the batches cannot all be sent inside the
      reminder window, no reminders go out for that draw at all.
    </p>

    <form [formGroup]="notificationDeliverySettingsForm">
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Notification Frequency (seconds)</mat-label>
        <input matInput type="number" data-testid="notification-frequency-input"
               placeholder="Enter notification frequency in seconds"
               formControlName="notificationFrequency">
        <mat-hint>Seconds between batches. 3600 = 1 hour, 1800 = 30 minutes</mat-hint>
        <mat-error data-testid="notification-frequency-error"
                   *ngIf="(notificationFrequencyControl.dirty || notificationFrequencyControl.touched) && notificationFrequencyControl.errors">
          Required and must be greater than 0
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="full-width margin-top-large">
        <mat-label>Notification Chunk Size</mat-label>
        <input matInput type="number" data-testid="notification-chunk-size-input"
               placeholder="Enter chunk size for notification batches"
               formControlName="notificationChunkSize">
        <mat-hint>Players per batch</mat-hint>
        <mat-error data-testid="notification-chunk-size-error"
                   *ngIf="(notificationChunkSizeControl.dirty || notificationChunkSizeControl.touched) && notificationChunkSizeControl.errors">
          Required and must be greater than 0
        </mat-error>
      </mat-form-field>
    </form>
  </ng-container>

  <ng-container actions>
    <button mat-button color="primary" data-testid="submit-notification-delivery-settings-button"
            (click)="submit()">Submit</button>
  </ng-container>
</app-dialog-base>
